import { Col, Row } from 'antd';
import { RevxCoverCard } from 'components/RevxCoverCard';
import { PaperSize } from 'components/RevxCoverCard/PaperSize';
import { SkuSize } from 'domains/skuDomain';
import { useMeasurementUnit } from 'hooks/useMeasurementUnit';
import { isEqual } from 'lodash-es';
import { useState } from 'react';

export interface SizeInputProps {
  options?: SkuSize[];
  value?: string;
  onChange?: (value: string) => void;
}
export const RevxsSizeRadioGroup = ({
  options = [],
  value,
  onChange,
}: SizeInputProps) => {
  const { displaySize } = useMeasurementUnit();
  const [val, setVal] = useState<string | undefined>(value);

  return (
    <Row gutter={[24, 32]}>
      {options.map((size) => {
        return (
          <Col>
            <RevxCoverCard
              title={displaySize(size.finishedSize, { metric: size.finishedSizeMetric })}
              checked={isEqual(val, size.flatSize)}
              onChange={() => {
                if (!isEqual(val, size.flatSize)) {
                  setVal(size.flatSize);
                  if (onChange) {
                    onChange(size.flatSize);
                  }
                }
              }}
            >
              {<PaperSize width={getWidth(size)} height={getHeight(size)} />}
            </RevxCoverCard>
          </Col>
        );
      })}
    </Row>
  );
};
function getWidth(size: SkuSize): number {
  return Number.parseFloat(
    size.widthLengthSize.substring(0, size.widthLengthSize.indexOf('x'))
  );
}

function getHeight(size: SkuSize): number {
  return Number.parseFloat(
    size.widthLengthSize.substring(size.widthLengthSize.indexOf('x') + 1)
  );
}
